import styled from 'styled-components';
import colors from '../../../../../styles/settings/colors'
import fontSize from '../../../../../styles/settings/fontSize'

export const AnchorLogo = styled.div`
  border: 2px solid #424242;
  margin: 0 0 8px;
  background-color: white;
  text-align: center;
  img {
    cursor: pointer;
    height: 100px;
    width: 100%;
    max-width: 200px;
    max-height: 80px;
  }
`;

export const MetasBox = styled.div`
  border-radius: 4px;
  /* box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%); */
`;

export const TableTitleHeader = styled.div`
  align-items: center;
  background-color: ${colors.sanMarino};
  border-radius: 4px 4px 0 0;
  color: #fff;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  overflow-y: hidden !important;
  padding: 0;

  .operation-title {
    font-size: ${fontSize.headerTable};
    font-weight: bold;
    margin: 0 auto;
    padding: 2px 4px;
  }

  .operation-actions {
    display: flex;
  }

  svg {
    color: white;
    margin-right: 8px;
    width: 15px;
  }
`;

export const MetasContainer = styled.div`
  p {
    margin: 0;
    padding: 0;
  }
  .metas-header {
    background: ${colors.sanMarino};
    color: #fff;
    display: flex;
    flex-flow: row nowrap;
    font-size: ${fontSize.tableRowText};
    font-weight: bold;
    justify-content: space-between;
    padding: 0 8px;
    p:first-child {
      text-align: left;
      width: 32%;
    }
    p {
      border-right: 1px solid white;
      width: 25%;
    }
    p:last-child {
      border-right: 0 solid white;
      text-align: right;
      width: 12%;
    }
  }
  .metas-body {
    display: flex;
    flex-flow: column wrap;
    .metas-body-row {
      align-items: center;
      display: flex;
      flex-flow: row nowrap;
      height: 24px;
      justify-content: space-between;
      font-size: ${fontSize.tableRowText};
      padding: 0 8px;
      &:nth-child(odd) {
        background-color: ${colors.oddColor};
      }
      &:nth-child(even) {
        background-color: ${colors.evenColor};
      }

      p:first-child {
        text-align: left;
        width: 32%;
      }
      p {
        border-right: 1px solid white;
        text-align: right;
        width: 25%;
      }
      p:last-child {
        border-right: 0px solid white;
        text-align: right;
        width: 12%;
      }
    }
  }
`;
